import React from 'react';
import { Link } from 'react-router-dom';
import { Star, Award, Heart, Users, CheckCircle, ArrowRight } from 'lucide-react';
import { siteInfo } from '../data/mock';

export const AboutPage = () => {
  const values = [
    {
      icon: Heart,
      title: 'Passion',
      description: 'Chaque prestation est réalisée avec amour et dévouement pour votre beauté.'
    },
    {
      icon: Award,
      title: 'Excellence',
      description: 'Nous utilisons les meilleures techniques et produits pour des résultats exceptionnels.'
    },
    {
      icon: Users,
      title: 'Bienveillance',
      description: 'Un accueil chaleureux dans un espace où vous vous sentez chez vous.'
    },
    {
      icon: Star,
      title: 'Expertise',
      description: 'Plus de 10 ans d’expérience dans la beauté afro et les cheveux texturés.'
    }
  ];

  const team = [
    {
      name: 'Yrène',
      role: 'Fondatrice & Coiffeuse experte',
      //image: 'https://images.unsplash.com/photo-1602580404246-225af00637ac?w=400',
      specialty: 'Spécialiste coiffure afro et européenne'
    },
    {
      name: 'Awa',
      role: 'Esthéticienne',
      //image: 'https://images.unsplash.com/photo-1639531167411-2fbab09f57f6?w=400',
      specialty: 'Experte soins visage'
    },
    {
      name: 'Fatima',
      role: 'Prothésiste ongulaire',
      //image: 'https://images.unsplash.com/photo-1667498235477-0dcfc8593de8?w=400',
      specialty: 'Nail art créatif'
    }
  ];

  return (
    <div className="min-h-screen bg-[#FDF8F3]">
      {/* Hero */}
      <section className="relative py-24 bg-[#2C1810]">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <span className="text-[#C9A96E] font-medium uppercase tracking-wider text-sm">Notre Institut</span>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mt-4 mb-6">
            À Propos de {siteInfo.name}
          </h1>
          <div className="w-20 h-1 bg-gradient-to-r from-[#C9A96E] to-[#A67B5B] mx-auto mb-6" />
          <p className="text-[#D4C4B5] text-lg max-w-2xl mx-auto">
            Découvrez l'histoire de notre institut et rencontrez notre équipe d'expertes passionnées
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-[#C9A96E] font-medium uppercase tracking-wider text-sm">Notre Histoire</span>
              <h2 className="text-4xl font-serif font-bold text-[#2C1810] mt-4 mb-6">
                Née de la passion pour la beauté
              </h2>
              <div className="w-20 h-1 bg-gradient-to-r from-[#C9A96E] to-[#A67B5B] mb-8" />
              <div className="space-y-4 text-[#5D4037] leading-relaxed">
                <p>
                  <strong className="text-[#2C1810]">{siteInfo.name}</strong> est né d'une conviction profonde : 
                  chaque femme mérite un espace où sa beauté naturelle est célébrée et magnifiée.
                </p>
                <p>
                  Fondé par <strong className="text-[#C9A96E]">Yrène</strong> à Asnières-sur-Seine il y a plus de 10 ans, 
                  notre institut est rapidement devenu une référence pour les femmes en quête de soins adaptés 
                  à leurs cheveux texturés et leur peau sublime. Spécialisé en coiffure afro, nous proposons 
                  également des coupes européennes telles que le brushing.
                </p>
                <p>
                  Aujourd'hui, avec plus d'une décennie d'expérience, nous continuons de porter cette mission 
                  avec fierté : "Faites-vous belle, vous le méritez." Nous proposons des prestations haut de gamme 
                  dans une ambiance chaleureuse et bienveillante.
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-10">
                <div className="text-center">
                  <p className="text-4xl font-serif font-bold text-[#C9A96E]">10+</p>
                  <p className="text-sm text-[#5D4037]">Années d'expérience</p>
                </div>
                <div className="text-center">
                  <p className="text-4xl font-serif font-bold text-[#C9A96E]">500+</p>
                  <p className="text-sm text-[#5D4037]">Clientes fidèles</p>
                </div>
                <div className="text-center">
                  <p className="text-4xl font-serif font-bold text-[#C9A96E]">5★</p>
                  <p className="text-sm text-[#5D4037]">Note moyenne</p>
                </div>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1639162906614-0603b0ae95fd?w=600"
                alt="Notre institut"
                className="rounded-2xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -left-6 bg-[#C9A96E] text-white p-6 rounded-2xl">
                <p className="text-3xl font-serif font-bold">2010</p>
                <p className="text-sm">Date de création</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-[#2C1810]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-[#C9A96E] font-medium uppercase tracking-wider text-sm">Nos Valeurs</span>
            <h2 className="text-4xl font-serif font-bold text-white mt-4 mb-6">
              Ce qui nous anime
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-[#C9A96E] to-[#A67B5B] mx-auto" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="bg-[#3E2723] rounded-2xl p-8 text-center">
                <div className="w-16 h-16 rounded-full bg-[#C9A96E]/20 flex items-center justify-center mx-auto mb-6">
                  <value.icon className="text-[#C9A96E]" size={32} />
                </div>
                <h3 className="text-xl font-serif font-semibold text-white mb-3">{value.title}</h3>
                <p className="text-[#D4C4B5] text-sm leading-relaxed">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team 
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-[#C9A96E] font-medium uppercase tracking-wider text-sm">Notre Équipe</span>
            <h2 className="text-4xl font-serif font-bold text-[#2C1810] mt-4 mb-6">
              Des expertes à votre service
            </h2>
            <div className="section-divider" />
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {team.map((member, index) => (
              <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg card-hover">
                <div className="h-80 overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6 text-center">
                  <h3 className="text-2xl font-serif font-semibold text-[#2C1810] mb-1">{member.name}</h3>
                  <p className="text-[#C9A96E] font-medium mb-2">{member.role}</p>
                  <p className="text-sm text-[#5D4037]">{member.specialty}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      */}

      {/* Commitments */}
      <section className="py-20 bg-[#F5F0EB]">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-serif font-bold text-[#2C1810] mb-6">
              Nos Engagements
            </h2>
            <div className="section-divider" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              'Produits de qualité professionnelle',
              'Respect de votre type de cheveux',
              'Conseils personnalisés',
              'Hygiène irréprochable',
              'Formation continue de nos équipes',
              'Satisfaction client garantie'
            ].map((commitment, index) => (
              <div key={index} className="flex items-center gap-4 bg-white p-5 rounded-xl">
                <CheckCircle className="text-[#C9A96E] flex-shrink-0" size={24} />
                <span className="text-[#2C1810] font-medium">{commitment}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gradient-to-r from-[#C9A96E] to-[#A67B5B]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6">
            Venez nous rencontrer
          </h2>
          <p className="text-white/90 text-lg mb-8">
            Réservez votre première visite et découvrez l'expérience Miss Baleng
          </p>
          <Link
            to="/reservation"
            className="bg-white text-[#2C1810] px-10 py-4 rounded-full text-lg font-semibold inline-flex items-center gap-2 hover:bg-[#FDF8F3] transition-colors"
          >
            Réserver
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>
    </div>
  );
};
